import { AuthModule, AuthState, AuthStore } from "@/store/auth";
import { createLogger, Plugin, Store } from "vuex";
import createPersistedState from "vuex-persistedstate";

import Vue from 'vue';
import Vuex from "vuex";

export type State = {
  auth: AuthState;
};

const addConditionalPlugins = (pluginArray: Plugin<State>[]) => {
  if (process.env.NODE_ENV === "development") {
    pluginArray.push(createLogger());
  }
  return pluginArray;
};

Vue.use(Vuex);

export const store = new Store ({
  modules: { AuthModule },
  plugins: addConditionalPlugins([
    createPersistedState({
      storage: localStorage,
    }),
  ]),
});

export type CurrentStore = AuthStore<Pick<State, "auth">>;

export function useStore(): CurrentStore {
  return store as CurrentStore;
}

